// @flow

import { combineReducers } from "redux";

import config from "./config";
import inactivity from "./inactivity";
import user from "./user";

/**
 * The root reducer
 */
export default combineReducers<*, *>({ user, config, inactivity });
